import {
  BrowserPopupNotificationActionNode,
  BrowserPushNotificationActionNode,
  CampaignEventType,
  CreateItemBannerActionNode,
  CreateVirtualSKUNode,
  EmailActionNode,
  GraphRoot,
  MobilePopupActionNode,
  MobilePushActionNode,
} from '@/api/dashboard'
import { findPrevEntityNode } from '../../util'
import { CONTEXT_ITEM, getContextItemText } from '@/layouts/campaigns/editors/common'
import { useMemo } from 'react'
import { EventActionNodeType } from '@/layouts/campaigns/types'
import { useGameItemsQuery } from '@/api/useGameItems'
import { useGenerateCompanyPath } from '@/libs'
import { Badge } from '@/ui'
import { useTranslation } from 'react-i18next'

export const DescCommunicationNode = ({
  node,
  graph,
  type,
}: {
  node:
    | BrowserPushNotificationActionNode
    | BrowserPopupNotificationActionNode
    | EmailActionNode
    | MobilePushActionNode
    | CreateItemBannerActionNode
    | MobilePopupActionNode
  graph: GraphRoot
  type?: CampaignEventType | string
}) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { t } = useTranslation()

  const itemId = useMemo(() => {
    if (node.link_created_offer) {
      const prevNode = findPrevEntityNode(graph.nodes!, node.id)

      if (prevNode?.model_type == EventActionNodeType.CreateUserStoreSettingsNode) {
        return ''
      }

      if (prevNode) {
        return (prevNode as CreateVirtualSKUNode).item_id
      }
    } else if ((node as BrowserPopupNotificationActionNode).item_id) {
      return (node as BrowserPopupNotificationActionNode).item_id
    }

    return ''
  }, [node])

  const { data: items = [] } = useGameItemsQuery(companyId, gameId, {
    ids: itemId,
    enabled: !!itemId && (node as BrowserPopupNotificationActionNode).item_id != CONTEXT_ITEM,
  })

  if ((node as BrowserPopupNotificationActionNode).item_id == CONTEXT_ITEM) {
    return getContextItemText(type as CampaignEventType)
  }

  if (!itemId) {
    return ''
  }

  if (!items.length) {
    return 'Item not found'
  }

  if (items.length) {
    const item = items[0]

    if (item && item.archived_at) {
      return (
        <>
          <Badge variant="red-secondary">{t('archived')}</Badge>
        </>
      )
    }

    return (
      <>
        {item.name} <Badge variant="gray-secondary">{item.sku}</Badge>
      </>
    )
  }

  return items[0].name
}
